import $ from 'jquery'

function init () {
  if ($('.glossary-module').length > 0) {
    $('.glossary-click-js').on('click', function (e) {
      e.preventDefault()

      let href = $(this).attr('href'),
        _href = href.replace('#', '#_'),
        el = $(_href)
      if (el.length > 0) {
        $('html, body').animate({
          scrollTop: el.offset().top - 150
        }, 1000, 'linear')
      }
    })

    let backToTopContainer = $('.back-to-top-container'),
      backToTop = $('.back-to-top-container .back-to-top'),
      glossaryFirst = $('.glossary-module').first()

    resizeScrollTop()
    positionScrollTop()
    $(window).on('scroll', () => {
      positionScrollTop()
    })

    $(window).on('resizeend', () => {
      resizeScrollTop()
    })

    function resizeScrollTop () {
      positionScrollTop()
    }

    function positionScrollTop () {
      if ($(window).scrollTop() > glossaryFirst.offset().top) {
        if ($(window).scrollTop() > glossaryFirst.offset().top - backToTop.height()) {
          if ($(window).scrollTop() >= (backToTopContainer.offset().top - $(window).height() + (backToTop.height() + 35))) {
            backToTop.parent().css('position', 'relative')
            backToTop.parent().css('bottom', '')
            backToTop.parent().removeClass('container')
            backToTopContainer.height('')
          } else {
            backToTop.parent().css('position', 'fixed')
            backToTop.parent().css('bottom', 35)
            backToTop.parent().addClass('container')
            backToTopContainer.height(backToTop.height())
          }
        }
      } else {
        backToTop.parent().css('position', 'relative')
        backToTop.parent().css('bottom', '')
        backToTop.parent().removeClass('container')
        backToTopContainer.height('')
      }
    }
  }

}

export default {
  init
}
